import { useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import constants from "../../../Utils/constants";
import { haveValue } from "../../../helper/common";
import LandlordProgressbar from "./LandlordProgressbar";
import { trackClarityEvent } from "../../../Utils/clarityReady";
import { Button } from "../../../components/design";

const UserRoleSelectionModal = ({
  progressStep,
  setCurrentStep,
  formData,
  setFormData,
}) => {
  const { _t } = useTranslator();
  const cards = [
    {
      id: constants.INDIVIDUAL_PROPERTY_OWNER,
      img: "/images/property-owner-icon.svg",
      titleKey: "iAmAnIndividualPropertyOwner",
    },
    {
      id: constants.REAL_ESTATE_AGENT,
      img: "/images/estate-agent-icon.svg",
      titleKey: "iAmARealEstateAgent",
    },
    {
      id: constants.ASSET_MANAGER,
      img: "/images/asset-manager-icon.svg",
      titleKey: "iAmAnAssetManager",
    },
  ];
  const [selected, setSelected] = useState(formData.professional_usage_type);

  const handleNextStep = () => {
    setCurrentStep((prev) => prev + 1);
    trackClarityEvent("landlord_options_better_defined_you_step_ended");
    setTimeout(() => {
      trackClarityEvent("landlord_many_properties_do_you_manage_step_started");
    }, constants.CLARITY_DELAY);
  };

  const handlePrevStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleSelectCard = (card_id) => {
    setSelected(card_id);
    setFormData((prev) => ({ ...prev, professional_usage_type: card_id }));
  };

  return (
    <div>
      <Modal
        show={true}
        // onHide={handleCloseModal}
        centered
        className="landlord-onboarding-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <h4>
              {_t(
                "whichOfTheFollowingOptionsBetterDefineYouNewLandlordOnboarding"
              )}
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{_t("pleaseSelectAnOption")}</p>
          <LandlordProgressbar step={progressStep + 1} />
          <div className="better-cards-comp">
            {cards.map((card) => (
              <div
                onClick={() => handleSelectCard(card.id)}
                className={`usage-card ${
                  selected === card.id ? "select-card " : ""
                }`}
                key={card.id}
              >
                <img src={card.img} alt={card.id + "-icon"} />
                <h3>{_t(card.titleKey)}</h3>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="landlord-modal-group-btn">
            <Button variant="secondary" size="lg" onClick={handlePrevStep}>
              {_t("back")}
            </Button>
            <Button
              size="lg"
              onClick={handleNextStep}
              disabled={!haveValue(formData.professional_usage_type)}
            >
              {_t("next")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserRoleSelectionModal;
